import { FC } from 'react'
import cx from 'classnames'

import * as Icons from 'common/icons'
import { Radio as RadioIcon } from 'common/icons'
import { IconType } from 'common/icons/Icon'
import { DistributionChannel as ResponseDistributionChannel } from 'common/interfaces/projects'

import DistributionChannel from '../DistributionChannel'

const mapDistributionChannelToIcon: {
  [key in ResponseDistributionChannel]: IconType
} = {
  sms: Icons.SmsLove,
  email: Icons.Email,
  push_notification: Icons.Push,
  email_in_body: Icons.Email,
  social_ad: Icons.Facebook,
  web_and_app: Icons.LandingPage,
}

type Props = {
  options: ResponseDistributionChannel[]
  onChange(type: ResponseDistributionChannel): void
  value?: ResponseDistributionChannel
  isDisabled?: boolean
}

const ChannelPicker: FC<Props> = ({
  options,
  onChange,
  isDisabled,
  value: selectedValue,
}) => {
  return (
    <>
      <div className="mb-2 text-sm text-coolGray-800 font-semibold">
        Channel
      </div>
      <div className="flex flex-wrap gap-6">
        {options.map((value) => {
          const Icon = mapDistributionChannelToIcon[value]
          const isSelected = value === selectedValue

          return (
            <label
              key={value}
              data-cy={`channel-option-label-${value}`}
              style={{ gridTemplateRows: '32px auto' }}
              className={cx(
                `relative w-27 grid justify-items-center gap-2 border-2 border-coolGray-300 
                pt-5 px-4 pb-4 rounded-md bg-white text-coolGray-800 font-medium
                cursor-pointer`,
                {
                  'border-orange-400 text-orange-500 bg-orange-50': isSelected,
                  'cursor-not-allowed': isDisabled,
                }
              )}
            >
              <input
                data-cy={`channel-option-input-${value}`}
                className="sr-only"
                type="radio"
                checked={isSelected}
                name="channel"
                onChange={() => onChange(value)}
                disabled={isDisabled}
              />
              <RadioIcon
                className="absolute top-2 right-2"
                size={5}
                state={isSelected ? 'selected' : 'default'}
              />
              <Icon size={8} state={isSelected ? 'selected' : 'default'} />
              <DistributionChannel
                data-cy={`channel-option-title-${value}`}
                value={value}
                className="self-center text-center"
              />
            </label>
          )
        })}
      </div>
    </>
  )
}

export default ChannelPicker
